import {proxy, useSnapshot} from 'valtio';
import {
  type StepWidgetStore,
  StepsPath,
  stepsMap,
} from '../routing/StepsRouting';
import type {
  GetNextBuyflowStepResponse,
  FooterWidget,
} from '@/lib/TypesOpenApi';
import {useWidget} from '../routing/StepsWizardContext';

const widget = stepsMap['SIGN_IN']!.store;

export interface SignInPageWidget {
  widget: StepWidgetStore;
  content?: GetNextBuyflowStepResponse;
  footerWidget?: FooterWidget;
}

export const signInWidget = proxy<SignInPageWidget>({
  widget,
  get content() {
    return this.widget.content;
  },
  get footerWidget() {
    const widgets =
      widget.content?.buyflowStep.buyflowWidgets
        ?.map(({footerWidget: w}) => w!)
        .filter(w => !!w) || [];
    return widgets[0];
  },
});

export const useSignInWidget = () => useWidget(StepsPath.SignIn, signInWidget);

export interface SignInState {
  enteredUserEmail?: string;
}

export const store = proxy<SignInState>({
  enteredUserEmail: undefined,
});

export const resetSignInState = () => {
  store.enteredUserEmail = undefined;
};

export const setEnteredEmail = (email: string) => {
  store.enteredUserEmail = email;
};

export const useSignInState = () => useSnapshot(store);
